<template>
    <div>
        <div v-if="!addProductToggle" class="text-right mt-3 mr-5">
            <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" title="Add New Product" @click="addProductToggle = !addProductToggle">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.add')}}{{$t('subMenu.salon_menu_product')}}</span>
            </button>
        </div>
        <div v-if="addProductToggle" class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr">
                    <h2>{{$t('button_link.add')}}{{$t('subMenu.salon_menu_product')}}</h2>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <productForm :isEdit="false" :category="category" @returnProductList="returnProductList"></productForm>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!addProductToggle" class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 p-3">
                    <div class="ml-auto mb-3 text-right">
                        <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                            :data="exportData"
                            :fields="exportFields"
                            :header="exportHeaders"
                            type="csv"
                            :escapeCsv="false"
                            :name="exportFileName">
                            <span>CSV</span>
                        </exportCSV>
                        <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> -->
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-4 mb-2 align-items-center justify-content-start">
                            <div class="dataTables_filter">
                                <label class="d-flex mb-0">
                                    <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="searchProduct" @keypress.enter="searchProductItem">
                                    <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0" @click="searchProductItem">
                                        <i class="fas fa-search"></i>
                                    </button>
                                </label>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4 mb-2">
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text border-right-0" >
                                            <i class="fas fa-store"></i>
                                        </label>
                                        <multiselect v-model="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet"></multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4 mb-2"> 
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text border-right-0">
                                            <i class="fas fa-tags"></i>
                                        </label>
                                        <multiselect 
                                            :value="selectedSubcategory" 
                                            :options="subCategory" 
                                            track-by="id" label="text" 
                                            :show-labels="false" 
                                            openDirection="below" 
                                            @select="filterBySubCategory">
                                            <span slot="noResult">{{$t('table.no_records')}}</span>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="custom-control custom-checkbox mb-2">
                        <input type="checkbox" class="custom-control-input" id="showEnabled" @change="filterEnable($event)" v-model="isEnable">
                        <label class="custom-control-label" for="showEnabled">{{$t('label.show_enable')}}</label>
                    </div>
                    <a class="link text-primary" @click="clearFilter()">{{$t('button_link.clear_filter')}}</a>
                </div>
                <div class="panel-container pb-3 show">
                    <div class="panel-content">
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item" v-for="c in category" :key="c.id">
                                <a :class="{'active': selectedTab == c.id}" class="nav-link" role="tab" @click="filterByCategory(c.id)">{{c.text}}</a>
                            </li>
                        </ul>
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
                            {{$t('table.no_records')}}
                        </div>
                        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                            <div class="row justify-content-end mt-2">
                                <div class="col-auto pt-2">
                                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                                </div>
                                <div class="col-auto">
                                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 overflow-auto">
                                    <b-table striped hover bordered :fields="fields" :items="productItems" responsive="sm">
                                        <template #cell(index)="data">
                                            {{ data.index + startPage }}
                                        </template>
                                        <template #cell(img)="data">
                                            <span v-if="data.item.image == ''">-</span>
                                            <img v-else class="img-thumbnail" :src="getImage(data.item.image)"/>
                                        </template>
                                        <template #cell(title)="data">
                                            <a class="text-primary fw-500 link" @click="showEditProduct(data.item)">{{data.item.title}}</a>
                                        </template>
                                        <template #cell(price)="data">
                                            {{formatPrice(data.item.price)}}
                                        </template>
                                        <template #cell(basePrice)="data">
                                            {{formatPrice(data.item.basePrice)}}
                                        </template>
                                        <template #cell(category)="data">
                                            {{getCategoryText(data.item.category, category)}}
                                        </template>
                                        <template #cell(subCategory)="data">
                                            {{data.item.folderID == "" ? '-' : getCategoryText(data.item.folderID, subCategory)}}
                                        </template>
                                        <template #cell(isEnable)="data">
                                            <span class="badge" :class="data.item.isEnable == 1 ? 'badge-primary' : 'badge-secondary'">{{data.item.isEnable == 1 ? $t('table.value.enable') : $t('table.value.disable')}}</span>
                                        </template>
                                        <template #cell(gallery)="data">
                                            <a class="link text-primary" :title="$t('button_link.view_update', {'item': $t('table.header.gallery')})" @click="editGallery(data.item)">
                                                <i class="fal fa-images fs-xl"></i>
                                            </a>
                                        </template>
                                        <template #cell(action)="data">
                                            <button type="button" class="btn btn-xs btn-outline-primary waves-effect waves-themed mr-2" :title="$t('button_link.stock_in_out')" @click="editStock(data.item)">
                                                +/-
                                            </button>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'show': editToggleModal }" class="modal fade">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{$t('header.edit') + $t('subMenu.salon_menu_product')}}
                            <small class="m-0 text-muted">{{$t('subMenu.salon_menu_product')}} - "{{sTitle}}"</small>
                        </h5>
                        <button type="button" class="close" @click="closeEdit">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <productForm ref="editProductForm" :isEdit="true" :category="category" @returnProductList="returnProductList" @renderProduct="renderProduct" @deleteProduct="deleteProduct"></productForm>
                    </div>
                </div>
            </div>
        </div>
        <productGallery ref="productGallery"></productGallery>
        <stockInOut ref="stockInOut" @returnParent="returnProductList"></stockInOut>
    </div>
</template>

<script>
import moment from 'moment'
import StockInOut from './../../salonReport/stock2/Stock_In_Out'
import ProductGallery from './Product_Gallery'
import ProductForm from './Product_Form'
import {formatPrice} from './../../../../assets/js/dashboard/utilities'
import {setReturnData, handleSessionExpired, getSubcategory, getCategoryText, setCategoryLabel}
from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'productList',
    components:{
        ProductForm, ProductGallery, StockInOut
    },
    data(){
        let fromPackage = localStorage.fromPackage != "true" ? false : true;
        return{
            type: 'product',
            isSpinnerShow: false,
            searchProduct: "", isEnable: true,
            outlet: [], selectedOutlet: {},
            category: [], selectedTab: "all", 
            subCategories: [], subCategory: [], selectedSubcategory: {},       
            productItems: [], selectedItem: {},
            addProductToggle: fromPackage, editToggleModal: false,
            sID: 0, sTitle: "",
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            exportHeaders: [], exportData: [], exportFileName: "" , productExportData: []
        }
    },
    computed:{
        fields(){
            return [
                { key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "img", label: this.$i18n.t('table.header.image'), thClass: 'thead-themed align-middle', tdClass: 'align-middle width-12'},
                { key: "itemID", label: this.$i18n.t('table.header.id', {'item': this.$i18n.t('subMenu.salon_menu_product')}), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "title", label: this.$i18n.t('table.header.title'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "total", label: this.$i18n.t('table.header.quantity'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "price", label: this.$i18n.t('table.header.price'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "basePrice", label: this.$i18n.t('table.header.base_price'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                { key: "category", label: this.$i18n.t('table.header.category'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "subCategory", label: this.$i18n.t('table.header.subcategory'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "isEnable", label: this.$i18n.t('table.header.enable'), thClass: 'thead-themed align-middle', tdClass: 'align-middle text-center'},
                { key: "gallery", label: this.$i18n.t('table.header.gallery'), thClass: 'thead-themed align-middle', tdClass: 'align-middle text-center'},
                { key: "action", label: "", thClass: 'thead-themed align-middle', tdClass: 'align-middle text-center'},
            ]
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.id', {'item': this.$i18n.t('subMenu.salon_menu_product')})).toUpperCase()] = "itemID"
            ret[(this.$i18n.t('table.header.title')).toUpperCase()] = "title"
            ret[(this.$i18n.t('table.header.quantity')).toUpperCase()] = "total"
            ret[(this.$i18n.t('table.header.price')).toUpperCase()] = "price"
            ret[(this.$i18n.t('table.header.base_price')).toUpperCase()] = "basePrice"
            ret[(this.$i18n.t('table.header.category')).toUpperCase()] = "category"
            ret[(this.$i18n.t('table.header.subcategory')).toUpperCase()] = "subCategory"
            ret[(this.$i18n.t('table.header.enable')).toUpperCase()] = "isEnable"
            return ret
        },
    },
     watch:{
        "$i18n.locale"(val){
            this.setLabel()
            
            var b = Object.assign({}, this.selectedSubcategory)
            this.selectedSubcategory = this.subCategory.filter(obj=> obj.id == b.id)[0]
            this.setExportData(this.productExportData)
        }
    },
    methods:{
        getImage(img){
            return img
        },
        formatPrice(price){
            return formatPrice(price);
        },
        getCategoryText(id, arr){
            return getCategoryText(id, arr)
        },
        returnProductList(){
            this.filterProductItem(this.selectedTab, this.selectedSubcategory.id, this.isEnable);
            this.addProductToggle = this.editToggleModal = false;
        },
        closeEdit(){
            this.editToggleModal = false
            this.$refs.editProductForm.image = ""
        },
        async closeModal(isError){
            if(!isError){
                this.addProductToggle = this.editToggleModal = false;
                this.clearFilter();
            }
            this.$parent.$parent.isModalShow = false;
        },
        clearFilter(){
            this.isEnable = true;
            this.searchProduct = "";
            this.filterByCategory("all");
        },
        searchProductItem(){
            var strFilter = this.searchProduct == "" ? "" : "&search=" + this.searchProduct;
            this.setProductItem(strFilter);

            this.selectedTab = "all";
            this.selectedSubcategory = this.subCategory[0];
            this.isEnable = true;
        },
        async filterByCategory(item){
            this.page = 0;
            this.selectedTab = item;

            var strFilter = item == "all" ? "" : "&category=" + item;
            this.subCategories = await getSubcategory(this, this.type, strFilter);
            this.setLabel()
            this.selectedSubcategory = this.subCategory[0]

            this.filterProductItem(this.selectedTab, 0, this.isEnable);
        },
        filterBySubCategory(item){
            this.selectedSubcategory = item;
            this.filterProductItem(this.selectedTab, this.selectedSubcategory.id, this.isEnable);
        },
        filterEnable(e){
            this.isEnable = e.target.checked ? true : false;
            this.filterProductItem(this.selectedTab, this.selectedSubcategory.id, this.isEnable);
        },
        filterByOutlet(item){
            this.selectedOutlet = item;
            this.filterProductItem(this.selectedTab, this.selectedSubcategory.id, this.isEnable);
        },
        filterProductItem(catID, subCatID, isEnable){
            var strCatFilter = catID == "all" ? "" : "&category=" + catID;
            var strSubCatFilter = subCatID == 0 ? "" : "&folderID=" + subCatID;
            var strFilterIsEnable = isEnable ? "&isEnable=1" : "&isEnable=0";
            var strFilter = strCatFilter + strSubCatFilter + strFilterIsEnable;
            this.setProductItem(strFilter);
        },
        async setProductItem(strFilter){
            this.isSpinnerShow = true
            var strDateFilter = "?startDate=01/01/1990&endDate=" + moment().format(this.$msg.CST.DATE_FORMAT);
            var stockBalanceItem = await this.getStockBalanceItem(strDateFilter)

            var objProduct = await this.getProductItem(strFilter)
            var productItems = objProduct.items

            let stockBalanceMap = {}
            for(let item of stockBalanceItem) {
                stockBalanceMap[item['sku']['skuID']] = item
            }

            productItems.forEach((e)=>{
                e['total'] = (stockBalanceMap[e['itemID']] || {})['total'] || 0
                return e
            })

            var retData = setReturnData(productItems, objProduct.count, this.page)
            this.productItems = retData.result;
            this.totalEntries = retData.count;
            this.totalPage = retData.totalPage;

            this.startPage = retData.startPage;
            this.endPage = retData.endPage;
            this.isSpinnerShow = false

            var expProductItems = await this.getExportData(strFilter)

            expProductItems.forEach((e)=>{
                e['total'] = (stockBalanceMap[e['itemID']] || {})['total'] || 0
                return e
            })
            this.productExportData = expProductItems
            this.setExportData(expProductItems)
        },
        async getStockBalanceItem(strFilter){
            let $vm = this;
            // const url =  $vm.$api.OUTLET + "/" + $vm.selectedOutlet.id + $vm.$api.STOCK_BALANCE + strFilter;
            let url = `https://menu.tunai.io/business/stock/balance?1=1`;

            url += '&date=' + moment().endOf('day').unix()

            if (this.selectedOutlet) {
                url += '&outletID=' + this.selectedOutlet.id
            }

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result= response.data.trxns;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        async getExportData(strFilter){
            let $vm = this;
            let QUERY_STRING =  "?type=" + this.type + strFilter
            const url =  this.$api.MENU_ITEM + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.items
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        setExportData(data){
            this.exportData = []

            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_menu_product`)
            this.exportHeaders = [
                header, 
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24),
                this.$i18n.t('label.outlet') + ': ' + this.selectedOutlet.text,
                " "];
            this.exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV

            for(var i=0; i<data.length; i++){
                this.exportData.push({
                    index: i+1,
                    itemID: data[i].itemID,
                    title: data[i].title,
                    total: data[i].total,
                    price: data[i].price,
                    basePrice: data[i].basePrice,
                    category: getCategoryText(data[i].category, this.category),
                    subCategory: data[i].folderID == "" ? '-' : getCategoryText(data[i].folderID, this.subCategory),
                    isEnable: data[i].isEnable == 1 ? this.$i18n.t('table.value.enable') : this.$i18n.t('table.value.disable')
                })
            }
        },
        async getProductItem(strFilter){
            let $vm = this;
            let QUERY_STRING =  "?type=" + this.type + "&page=" + this.page + strFilter
            const url =  this.$api.MENU_ITEM + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data
                // var retData = setReturnData(response.data.items, response.data.count, $vm.page)
                // $vm.productItems = retData.result;
                // $vm.totalEntries = retData.count;
                // $vm.totalPage = retData.totalPage;

                // $vm.startPage = retData.startPage;
                // $vm.endPage = retData.endPage;
                // $vm.isSpinnerShow = false;
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
            // await this.getExportData(strFilter)
        },
        addProduct(data){
            let $vm = this
            this.$axios({
                method: 'post', 
                url: this.$api.MENU_ITEM,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()},
                data: data
            })
            .then((response) => {
                if(response.status == 200){
                    var retData = response.data;
                    var message = "'" + retData.title + "'" + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.add')})
                    $vm.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }else{
                    $vm.$parent.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        showEditProduct(item){
            this.selectedItem = item
            this.sTitle = item.title;
            this.editToggleModal = true;    
            this.$refs.editProductForm.editProductForm(item, this.category);
        },
        async renderProduct(){
            await this.setProductItem("")

            var item = {}
            for(var i=0; i<this.productItems.length; i++){
                if(this.productItems[i].itemID == this.selectedItem.itemID){
                    item = this.productItems[i]
                    break
                }
            }
            this.$refs.editProductForm.editProductForm(item, this.category);
        },
        editProduct(data){
            let $vm = this
            let QUERY_STRING = "/" + this.sID + this.$api.UPDATE
            const url =  this.$api.MENU_ITEM + QUERY_STRING;

            this.$axios({
                method: 'post', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()},
                data: data
            })
            .then((response) => {
                if(response.status == 200){
                    var retData = response.data;
                    var message =  "'" + retData.title + "'" + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.update')})
                    $vm.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }else{
                    $vm.$parent.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        deleteProduct(id, title){
            this.sTitle = title;
            let $vm = this;
            this.deleteToggleModal = true;    
            document.getElementById('btnDeleteYes').onclick = function(){
                let QUERY_STRING = "/" + id + "/delete"
                const url =  $vm.$api.MENU_ITEM + QUERY_STRING;
                
                $vm.$axios({
                    method: 'post', 
                    url: url,
                    baseURL: $vm.$axios.defaults.baseURL, 
                    headers: {token: $vm.$session.get('token')},
                })
                .then((response) => {
                    if(response.status == 200){
                        $vm.deleteToggleModal = false;
                        var message = "Product item deleted successfully."
                        $vm.$parent.$parent.setModal(false, true, message);
                    }
                })
                .catch((err) => {
                    var error = err.response.data.error;
                    if(error == $vm.$api.INVALID_TOKEN){
                        handleSessionExpired();   
                    }
                })
            }
        },
        editGallery(item){
            this.$refs.productGallery.editProductGallery(item.itemID, item.title)
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1
                this.filterProductItem(this.selectedTab, this.selectedSubcategory.id, this.isEnable);
            }
        },
        editStock(item){
            var obj = {
                folderID: this.selectedSubcategory,
                items: item
            }
            var outlet = JSON.parse(this.$store.state.outlets);
            this.$refs.stockInOut.stockInOut(outlet[0], obj);
        },
        setLabel(){
            var category = JSON.parse(this.$store.state.category);
            this.category = setCategoryLabel(this, true, this.$i18n.t('label.all', {'item': this.$i18n.t('label.category')}), category.product)
            this.subCategory = setCategoryLabel(this, false, this.$i18n.t('label.all', {'item': this.$i18n.t('label.subcategory')}), this.subCategories)
        },
    },
    async mounted(){
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0];

        $vm.subCategories = await getSubcategory($vm, $vm.type, "");
        $vm.setLabel()
        
        $vm.selectedSubcategory = $vm.subCategory[0]
        $vm.setProductItem("");
    }
}
</script>

<style scoped>
.nav-link, .link{
    cursor: pointer;
}
.link > i {
    font-size: large;
}
.modal-body{
    max-height: 65vh;
    overflow-y: auto;
}
.show{
    display: block;
}
.modal-lg{
    max-width: 1000px;
}
</style>